import React, { useState } from "react";
import PropTypes from "prop-types";
import BaseMenu from "./base-menu";
import MenuItem from "./menu-item";
import style from "./retailer-selector.css";
import SVGIcon from "../common/svg-icon";
import analytics from "analytics/analytics";
import globals from "modules/globals";
import QuickFilters from "../quick-filters/quick-filters";
import { gender, genderShort } from "./constants";

const defaultSearchText = "";


function RetailerSelector({
    selectedGender,
    selectedProductType,
    selectedCategory,
    retailersData,
    selectedRetailers,
    setSelectedRetailers,
    genderedCategoriesData
}) {
    const [searchText, setSearchText] = useState(defaultSearchText);
    const searchURL = getSearchURL(
        selectedGender,
        genderedCategoriesData,
        retailersData,
        selectedProductType,
        selectedCategory,
        selectedRetailers
    );

    const filteredRetailersData = retailersData.filter(
        ({name}) => {
            return (
                searchText === defaultSearchText ||
                name.toLowerCase().includes(searchText.toLowerCase())
            );
        }
    );

    return (
        <BaseMenu>
            {selectedCategory ? (
                <div className={style.container}>
                    <div>
                        <p className={style.description}>
                            Which store do you normally shop at
                            for {selectedCategory.toLowerCase()}?
                        </p>
                        {selectedRetailers.length > 0 && (
                            <QuickFilters
                                items={selectedRetailers}
                                onClick={clickedValue => onRetailerClick(true, clickedValue)}
                            />
                        )}

                        <div className={style.searchBar}>
                            <div className={style.searchIcon}>
                                <SVGIcon name="search" />
                            </div>
                            <input
                                className={style.searchInput}
                                type="search"
                                placeholder="Search for a specific store"
                                aria-label="Search for a specific store"
                                onChange={onChangeSearchText}
                                value={searchText}
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className={style.searchButton}
                        onClick={() => onSearchButtonClick(searchURL)}
                    >
                        Search
                    </button>
                    <div className={style.retailerSelectSection}>
                        <ul>
                            {filteredRetailersData.map(({ name }, index) => {
                                const isSelected = selectedRetailers.includes(name);
                                return (
                                    <MenuItem
                                        value={name}
                                        key={index}
                                        onClick={() => onRetailerClick(isSelected, name)}
                                        icon="tick"
                                        displayIcon={isSelected}
                                    />
                                );
                            })}
                        </ul>
                    </div>
                </div>
            ) : null}
        </BaseMenu>
    );

    function onRetailerClick(isSelected, value) {
        if (isSelected) {
            // remove retailers
            analytics.event("ventory nav", "unselect retailer", value);
            setSelectedRetailers([...selectedRetailers.filter(item => item !== value)]);
        } else {
            analytics.event("ventory nav", "select retailer", value);
            setSelectedRetailers([value, ...selectedRetailers]);
        }
    }

    function onSearchButtonClick() {
        analytics.event("ventory nav", "clicked search", selectedRetailers.length);
        globals.window.location = searchURL;
    }

    function onChangeSearchText(e) {
        setSearchText(e.target.value);
    }

    function getSearchURL(
        selectedGender,
        genderedCategoriesData,
        retailersData,
        selectedProductType,
        selectedCategory,
        selectedRetailers
    ) {
        if (!selectedProductType || !selectedCategory) {
            return "";
        }

        const productType = genderedCategoriesData.filter(productType => {
            return productType.name === selectedProductType;
        })[0];

        const category = productType.categories.filter(category => {
            return category.name === selectedCategory;
        })[0];

        let url = `/explore/?${getParams(selectedRetailers)}`;

        return url;

        function getParams(selectedRetailers) {
            const params = retailersData
                .filter(({ name }) => selectedRetailers.includes(name))
                .map(({ value }) => {
                    return `retailer_slug=${value}`;
                });

            params.push(`gender=${selectedGender === genderShort.men ? gender.men : gender.women}`);
            params.push(`product_type=${productType.value}`);
            params.push(`category=${category.value}`);

            return params.join("&");
        }
    }
}

export default RetailerSelector;

RetailerSelector.propTypes = {
    selectedGender: PropTypes.oneOf([genderShort.men, genderShort.women]).isRequired,
    selectedProductType: PropTypes.string,
    selectedCategory: PropTypes.string,
    retailersData: PropTypes.array.isRequired,
    selectedRetailers: PropTypes.array.isRequired,
    setSelectedRetailers: PropTypes.func.isRequired,
    genderedCategoriesData: PropTypes.array.isRequired
};

RetailerSelector.defaultProps = {
    selectedProductType: null,
    selectedCategory: null
};
